
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-lime-400 rounded-lg flex items-center justify-center">
                <i className="ri-brush-line text-black text-xl"></i>
              </div>
              <span className="text-2xl font-bold">SA House Painters</span>
            </div>
            <p className="text-gray-300 mb-8 max-w-md text-lg leading-relaxed">
              South Africa's premier house painters directory. Connect with verified professional painting contractors across all provinces for quality painting services.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-300 hover:text-lime-400 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-2xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-lime-400 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-2xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-lime-400 transition-colors cursor-pointer">
                <i className="ri-twitter-line text-2xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-lime-400 transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-2xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Services</h3>
            <ul className="space-y-3">
              <li>
                <span className="text-gray-300 text-base">
                  Interior Painting
                </span>
              </li>
              <li>
                <span className="text-gray-300 text-base">
                  Exterior Painting
                </span>
              </li>
              <li>
                <span className="text-gray-300 text-base">
                  Commercial Painting
                </span>
              </li>
              <li>
                <span className="text-gray-300 text-base">
                  Roof Painting
                </span>
              </li>
              <li>
                <span className="text-gray-300 text-base">
                  Waterproofing
                </span>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Contact Info</h3>
            <div className="space-y-4 text-gray-300">
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-lime-400 text-lg"></i>
                <span className="text-base">info@sahousepainters.co.za</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-lime-400 text-lg"></i>
                <span className="text-base">Cape Town, South Africa</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-time-line text-lime-400 text-lg"></i>
                <span className="text-base">Mon-Fri: 8:00-17:00</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 text-sm mb-4 md:mb-0">
            © 2024 SA House Painters Directory. All rights reserved.
          </p>
          <div className="flex items-center space-x-4 text-sm">
            <a 
              href="https://seostudio.co.za/" 
              target="_blank" 
              rel="nofollow noopener noreferrer"
              className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
            >
              SEO by SEO Studio
            </a>
            <span className="text-gray-400">|</span>
            <a 
              href="https://leaderr.co/" 
              target="_blank" 
              rel="nofollow noopener noreferrer"
              className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
            >
              Powered by leaderr
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}
